export default __webpack_public_path__ + "static/media/ZA_WARUDO.ea74c22d.mp3";